
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clm/integrations",
      function () {
        return require("private-next-pages/clm/integrations/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clm/integrations"])
      });
    }
  